import React, { useState, useEffect } from "react";
import axios from "axios";
import swal from "sweetalert";
import {
  FaStar,
  FaSearch,
  FaTrashAlt,
  FaComments
} from "react-icons/fa";

export default function AdminReviews() {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");

  const fetchReviews = () => {
    setLoading(true);
    axios.get("/api/view-products").then((res) => {
      if (res.data.status === 200) {
        const prods = res.data.products || [];
        const initialReviews = [];
        prods.forEach((p) => {
          if (p.reviews && p.reviews.length > 0) {
            p.reviews.forEach((r) => {
              initialReviews.push({ ...r, productName: p.name });
            });
          }
        });
        setReviews(initialReviews);
      }
      setLoading(false);
    }).catch(() => {
      setLoading(false);
    });
  };

  useEffect(() => {
    document.title = "Product Reviews — Admin";
    fetchReviews();
  }, []);

  const handleDelete = (id) => {
    swal({
      title: "Delete Review?",
      text: "Are you sure you want to remove this customer review?",
      icon: "warning",
      buttons: ["Cancel", "Delete"],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        setReviews((prev) => prev.filter((r) => r.id !== id));
        swal("Removed", "Review deleted successfully", "success", { buttons: false, timer: 1000 });
      }
    });
  };

  const filtered = reviews.filter((r) => {
    const q = searchQuery.toLowerCase();
    return (
      (r.name || "").toLowerCase().includes(q) ||
      (r.comment || "").toLowerCase().includes(q) ||
      (r.productName || "").toLowerCase().includes(q)
    );
  });

  return (
    <div>
      {/* Header */}
      <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 mb-4">
        <div>
          <h4 className="fw-bold mb-1" style={{ color: "var(--admin-text-main)" }}>
            Product Reviews & Ratings
          </h4>
          <p className="text-muted mb-0" style={{ fontSize: "13.5px" }}>
            Monitor and moderate shopper ratings and feedback on store products
          </p>
        </div>
      </div>

      {/* Main Card */}
      <div className="admin-card">
        <div className="admin-card-header flex-wrap gap-3">
          <div className="position-relative" style={{ width: "300px" }}>
            <input
              type="text"
              className="form-control form-control-sm ps-4"
              placeholder="Search reviews..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              style={{ borderRadius: "8px" }}
            />
            <span className="position-absolute start-0 top-50 translate-middle-y ms-2 text-muted" style={{ fontSize: "11px" }}>
              <FaSearch />
            </span>
          </div>

          <span className="text-muted" style={{ fontSize: "13px" }}>
            Showing {filtered.length} reviews
          </span>
        </div>

        <div className="table-responsive">
          {loading ? (
            <div className="p-5 text-center">
              <div className="spinner-border text-primary" role="status"></div>
            </div>
          ) : filtered.length === 0 ? (
            <div className="p-5 text-center">
              <FaComments size={36} className="text-muted mb-2" />
              <h6 className="fw-bold">No Reviews Yet</h6>
              <p className="text-muted mb-0" style={{ fontSize: "13px" }}>
                Product reviews submitted by shoppers on product detail pages will appear here.
              </p>
            </div>
          ) : (
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Product</th>
                  <th>Customer</th>
                  <th>Rating</th>
                  <th>Comment</th>
                  <th>Date</th>
                  <th className="text-end">Action</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((r, idx) => (
                  <tr key={idx}>
                    <td>
                      <span className="fw-bold text-dark">{r.productName || "Product"}</span>
                    </td>
                    <td>
                      <span className="fw-semibold text-dark">{r.name || "Verified Shopper"}</span>
                    </td>
                    <td>
                      <div className="d-flex text-warning gap-1">
                        {[...Array(5)].map((_, i) => (
                          <FaStar
                            key={i}
                            size={12}
                            color={i < (r.rating || 5) ? "#f59e0b" : "#e2e8f0"}
                          />
                        ))}
                      </div>
                    </td>
                    <td>
                      <p className="mb-0 text-muted" style={{ maxWidth: "340px", fontSize: "13px" }}>
                        "{r.comment || "Great product quality!"}"
                      </p>
                    </td>
                    <td>
                      <small className="text-muted">
                        {r.created_at ? new Date(r.created_at).toLocaleDateString("en-PK", { dateStyle: "medium" }) : "Recent"}
                      </small>
                    </td>
                    <td className="text-end">
                      <button
                        type="button"
                        onClick={() => handleDelete(r.id)}
                        className="btn btn-sm btn-outline-danger rounded-2"
                        title="Delete Review"
                      >
                        <FaTrashAlt size={12} />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}
